import BaseScene from "@Scenes/BaseScene";

/*---------------- Config --------------------*/
import * as Scenes from '@Config/scenes';
import AnalyticsEvents from '@Config/analytics_events';

/*----------------- Core ---------------------*/
import Game from '@Game';
import Network from '@Networks/Localhost';
import EventEmitter from '@Utils/Events/EventEmitter';

/*----------------- Scene --------------------*/

class InterstitialScene extends BaseScene
{
    private loadingCircle: Phaser.GameObjects.Graphics;

    constructor()
    {
        super(Scenes.INTERSTITIAL);
    }

    /**
     * Creates the scene
     */
    public create()
    {
        this.cameras.main.setBackgroundColor('rgba(255,255,255,0.4)');

        this.addLoadingCircle();

        if (this.shouldShowInterstial())
        {
            this.showInterstitial();
        }
        else
        {
            this.emitCompleteEvent();
        }
    }

    /**
     * Updates the scene
     */
    public update()
    {
        this.loadingCircle.angle += 10;
    }

    /**
     * Adds loading circle to the scene
     */
    private addLoadingCircle()
    {
        const gameSize = this.getGameSize();

        const loadingCircle = this.add.graphics();
        loadingCircle.lineStyle(2, 0x000000);
        loadingCircle.beginPath();
        loadingCircle.arc(0, 0, 10, 0, (Math.PI * 2) * 0.85);
        loadingCircle.strokePath();
        loadingCircle.x = gameSize.width / 2;
        loadingCircle.y = 280;

        this.loadingCircle = loadingCircle
    }

    /**
     * Emits complete event
     */
    private emitCompleteEvent()
    {
        EventEmitter.emit(Scenes.INTERSTITIAL, 'complete');
    }

    /**
     * Should should interstitial
     */
    private shouldShowInterstial()
    {
        let shouldShow = false;

        const adsManager = Game.adsManager;

        if (adsManager.hasInterstitialSupport())
        {
            if (adsManager.isInterstitialLoaded())
            {
                if (adsManager.getTimeSinceLastInterstitial() > (1000 * 60 * 5))
                {
                    shouldShow = true;
                }
            }
            else
            {
                adsManager.loadInterstitialVideo().catch(error =>
                {
                    Network.logEvent(AnalyticsEvents.FAILED_TO_LOAD_INTERSTITIAL, null, { error_code: error.code, non_interaction: 'true' });
                });
            }
        }

        return shouldShow;
    }

    /**
     * Should interstitials
     */
    private async showInterstitial()
    {
        try
        {
            await Game.adsManager.showInterstitialVideo();

            Network.logEvent(AnalyticsEvents.INTERSTITAL_SHOWN);
        }
        catch (error)
        {
            Network.logEvent(AnalyticsEvents.FAILED_TO_SHOW_INTERSTITIAL);
        }

        this.emitCompleteEvent();
    }
}

export default InterstitialScene;